export const environment = {
  production: true,
  baseUrl: 'https://tiaky-arc.tim.it/ingestion/api/v1',
  api: {
    search: '/api/v1',
    history: '/ingestion/api/v1/history',
    generatedDocuments: '/ingestion/api/v1/generated-documents',
    upload: 'documents/user-upload',
    status:'documents/status',
    presigned_url: 'files/presigned-url'
  },
  host: 'https://tiaky-arc.tim.it',
  socketPath: '/ingestion/api/v1/task-socket',
  keycloak: {
    url: 'https://auth.tiaky-arc.tim.it/',
    realm: 'tiaky-arc',
    clientId: 'web-console',
  },
};
